import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class UserManagementService {
    constructor(private apiHttp: ApiHttp) {
    }

    public createRole(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUserManagement/createRole', data, messageService);
    }

    public createUser(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUserManagement/createUser', data, messageService);
    }

    public updateUser(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUserManagement/UpdateUser', data, messageService);
    }

    public updatePermissions(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUserManagement/updatePermissions', data, messageService);
    }

    public getPermissionsByRoleId(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUserManagement/GetPermissionsByRoleId', data, messageService);
    }

    public getRoles(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUserManagement/GetRoles', data, messageService);
    }

    public getUsers(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUserManagement/GetUsers', data, messageService);
    }
}
